import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { localizedText, type KanjiMathematicsEntry } from "../../consts/kanjiMathematics";
import styles from "./kanjiEquation.module.scss";

interface KanjiEquationProps {
    entry: KanjiMathematicsEntry;
    size?: "card" | "preview";
}

export default function KanjiEquation({ entry, size = "card" }: KanjiEquationProps) {
    const { t, i18n } = useTranslation("kanjiMathematicsPage");
    const language = i18n.language;
    const parts = entry.components.map((component) => localizedText(component.meaning, language)).join(` ${t("equation.plus")} `);
    const label = t("equation.label", { parts, result: localizedText(entry.result.gloss, language) });
    const className = size === "preview" ? `${styles.equation} ${styles.preview}` : styles.equation;

    return (
        <span className={className} role="img" aria-label={label}>
            <span className={styles.sum}>
                {entry.components.map((component, index) => (
                    <Fragment key={`${component.symbol}-${index}`}>
                        {index > 0 && (
                            <>
                                {" "}
                                <span className={styles.operator} aria-hidden="true">+</span>{" "}
                            </>
                        )}
                        <span className={styles.kanji} lang="ja" aria-hidden="true">{component.symbol}</span>
                    </Fragment>
                ))}
            </span>{" "}
            <span className={styles.answer}>
                <span className={styles.operator} aria-hidden="true">=</span>{" "}
                <span className={`${styles.kanji} ${styles.result}`} lang="ja" aria-hidden="true">{entry.result.symbol}</span>
            </span>
        </span>
    );
}
